const SLIDER_TYPES = {
    AGE: 'slider--age',
    MILEAGE: 'slider--mileage',
    PRICE: 'slider--price',
};

var ignoreEventsOnSet = false; // Globální proměnná pro řízení událostí

function updateHistogram(values, target) {
    $(document).trigger('updateHistogram', [values, target]);
}

function setSliderValues($slider, min, max) {
    ignoreEventsOnSet = true;
    $slider[0].noUiSlider.set([min, max]);
    ignoreEventsOnSet = false;
}

document.addEventListener('livewire:navigated', function () {
    initializeFilterSliders();

    function initializeFilterSliders() {
        'use strict';

        const $filterSliders = $('.filterSlider');

        function getIntegers(values, units = '') {
            for (var i = 0; i < values.length; i++) {
                values[i] = values[i].replace(units, '').replace(',', '').replace(/\s/g, '');
                values[i] = parseInt(values[i]);
            }
            return values;
        }

        function formatValue(value, units, thousandsSep = false) {
            var formattedValue = thousandsSep ? Math.round(value).toLocaleString(thousandsSep) : Math.round(value);
            return formattedValue + ' ' + units;
        }

        function initSlider($slider) {
            const data = $slider.data();
            const units = data.units ?? '';
            const unitsFirst = $slider.data('units-first') ?? false;
            const thousandsSep = data.thousandsSep ?? false;

            if ($slider[0].noUiSlider) {
                return;
            }

            if ($slider.hasClass(SLIDER_TYPES.PRICE)) {
                updateHistogram([data.defaultMin, data.defaultMax], $('.filterByPrice--small .histogram__item'));
            }

            var format = {
                to: function (value) {
                    var valuePart = thousandsSep ? (Math.round(value).toLocaleString(thousandsSep)) : Math.round(value);
                    if (unitsFirst) {
                        return units + ' ' + valuePart;
                    }
                    return valuePart + ' ' + units;
                },
                from: function (value) {
                    return Math.round(value);
                }
            };

            noUiSlider.create($slider[0], {
                start: [data.defaultMin, data.defaultMax],
                step: data.step,
                connect: true,
                tooltips: false,
                format: format,
                range: {
                    'min': [data.start],
                    'max': [data.end]
                }
            });

            $slider[0].noUiSlider.on('set', function (values, handle) {
                if (!ignoreEventsOnSet) {
                    var filterLivewire = eval($('#filterLivewire').data('livewire'));
                    values = getIntegers(values, units);

                    if ($slider.hasClass(SLIDER_TYPES.AGE)) {
                        filterLivewire.set('filterAgeFrom', (new Date()).getFullYear() - values[1]);
                        filterLivewire.set('filterAgeTo', (new Date()).getFullYear() - values[0]);
                    } else if ($slider.hasClass(SLIDER_TYPES.MILEAGE)) {
                        filterLivewire.set('filterMileageFrom', values[0]);
                        filterLivewire.set('filterMileageTo', values[1]);
                    } else if ($slider.hasClass(SLIDER_TYPES.PRICE)) {
                        updateHistogram(values, $('.filterByPrice--small .histogram__item'));
                        filterLivewire.set('filterPriceFrom', values[0]);
                        filterLivewire.set('filterPriceTo', values[1]);
                    }
                }
            });

            $slider[0].noUiSlider.on('update', function (values, handle) {
                values = getIntegers(values, units);
                if ($slider.hasClass(SLIDER_TYPES.MILEAGE) || $slider.hasClass(SLIDER_TYPES.PRICE)) {
                    $slider.find('.filterSlider__tooltip--min').text(formatValue(values[0], units, thousandsSep));
                    $slider.find('.filterSlider__tooltip--max').text(formatValue(values[1], units, thousandsSep));
                } else {
                    $slider.find('.filterSlider__tooltip--min').text(values[0]);
                    $slider.find('.filterSlider__tooltip--max').text(values[1]);
                }
            });
        }

        function initSliders() {
            for (var slider of $filterSliders) {
                initSlider($(slider));
            }
        }

        initSliders();
    }

    initializeFilterSliders();
});
